import { styled } from '@mui/material/styles'

const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  overflow: 'hidden auto',
  flex: '1 0',
  flexBasis: 'inherit',
  padding: '1rem',
  justifyContent: 'space-between',
}))

export default Form
